import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useGetActivitiesBySubTopic } from '../../../hooks/useGetActivitiesBySubTopic';
import { tasksId } from '../../../types/activityTasks';
import ObserverEmitter, { EVENTS } from '../../../emitter/Observer';
import { audiosAssets } from '../../../assets/audio';
import { ButtonPlay } from '../../../components/common/ButtonPlay';
import { ButtonHome } from '../../../components/common/ButtonHome';
import { HeaderRedPresentation } from '../../../components/common/HeaderRedPresentation';
import { DialogBarNew } from '../../../components/common/DialogBarNew';
import { PanelActivities } from '../../../components/common/PanelActivities';
import { BarStatusActivies } from '../../../components/common/BarStatusActivies';
import { RandomQuestion } from '../../../components/common/RandomQuestion';
import { shuffleArray } from '../../../helpers/questionRandom';
import { ValidationResultModal } from '../../../components/common/ValidationResultModal';
import { completeOneTask } from '../../../store/slices/menu/tunks';
import { imgTema2 } from '../../../assets/tema2';
import { voicesTypeControl } from '../../../types/audioType';
import { ButtonReturn } from '../../../components/common/ButtonReturn';

const steps = {
	dialogInitial: 1,
	panelActivity: 2,
	gameAnswer: 3,
	win: 4,
	fail: 5
};

const stepGame = [
	{
		id: 0,
		title: "Paso 1",
		text: "Mezla 3 litros de agua purificada usando una bolsa de Frappé hasta que se disuelva por completo.",
		img: imgTema2.maquinaPaso1
	},
	{
		id: 1,
		title: "Paso 2",
		text: "Asegúrate de que la máquina esté apagada antes de verter el contenido de la jarra en el contenedor.",
		img: imgTema2.maquinaPaso2
	},
	{
		id: 3,
		title: "Paso 3",
		text: "Llena los contenedores y coloca las tapas asegurándote de que encajen bien, después enciende la máquina.",
		img: imgTema2.maquinaPaso3
	},
	{
		id: 4,
		title: "Paso 4",
		text: `Localiza el switch general y presiona el botón alarm/reset y coloca el corbatín "en preparación".`,
		img: imgTema2.maquinaPaso4
	},
	{
		id: 5,
		title: "Paso 5",
		text: "Verifica que la temperatura sea de (-3°C) en la pantalla y coloca la fecha de caducidad de 7 días en el corbatín junto al contenedor.",
		img: imgTema2.maquinaPaso5
	},
];

export const Team2SubtopicTwoActivitySeven = () => {
	const navigator = useNavigate();
	const dispatch = useDispatch()
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema2.activities.subtema2], 7);

	useEffect(() => {
		if (loaded) {
			console.log('tema 2 sub 2 act 7');
			ObserverEmitter.emit(EVENTS.team2.subtopicTwo.initScene, 7);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act7_a01T2)
	})


	const [numberQuestion, setNumberQuestion] = useState(0);
	const [questionGameOne, setQuestionGameOne] = useState([]);
	const [saveResponsesGameOne, setSaveResponsesGameOne] = useState([]);
	const [responseQuestionGameOne, setResponseQuestionGameOne] = useState([]);


	const checkCorrectsInGameOne = (array = []) => {
		const trueElements = array.filter(element => element === true);
		return trueElements.length >= 3;
	}

	const getRandomQuestionGame = useCallback(() => {
		const newQuestion = shuffleArray(stepGame);
		const newResponse = stepGame
		setQuestionGameOne(newQuestion);
		setResponseQuestionGameOne(newResponse);
	}, []);

	useEffect(() => {
		getRandomQuestionGame();
	}, [getRandomQuestionGame]);

	const finishSubactivityOne = (isWin = false) => {
		ObserverEmitter.emit(EVENTS.characterAnimations.idle);
		if (isWin) {
			setUiToShow(steps.win);
		} else {
			setUiToShow(steps.fail);
		}
	};

	const verificationResponse = (selectNumber = -1) => {
		if (selectNumber === -1) {
			return;
		}

		if (numberQuestion + 1 >= questionGameOne.length + 1) {
			const resultadoThreeWin = checkCorrectsInGameOne(saveResponsesGameOne)
			finishSubactivityOne(resultadoThreeWin);
			return;
		}

		//* verificar si es correcto
		const isCorrectResponse = questionGameOne[numberQuestion].id === selectNumber;
		const saveGame = [...saveResponsesGameOne, isCorrectResponse];

		if (numberQuestion + 1 === questionGameOne.length) {
			const resultadoThreeWin = checkCorrectsInGameOne(saveGame)
			finishSubactivityOne(resultadoThreeWin);
			return;
		}


		//* guardar state
		// setResponseQuestionGameOne(shuffleNewResponse);
		setNumberQuestion(numberQuestion + 1);
		setSaveResponsesGameOne(saveGame);
	};

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, -1, -2, 3].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.team2.subtopicTwo.initScene, 7);
						setNumberQuestion(0)
						getRandomQuestionGame()
						setSaveResponsesGameOne([])
						setUiToShow(1)
					}} />
				)}
			</>

			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name="Actividad 7: Evaluación" />
					<DialogBarNew
						dialog={
							"¡Muy bien! Pongamos a prueba tus conocimientos. Preparemos un delicioso Frappé, relacionando la columna de imágenes con sus respectivos pasos."
						}
						percentage={"50%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.panelActivity);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.panelActivity && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 2: Máquinas de café"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							setUiToShow(steps.gameAnswer);
						}}
						activities={tasksList}
					/>
				</>
			)}

			{uiToShow === steps.gameAnswer && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<BarStatusActivies activities={tasksList} />
					<RandomQuestion
						action={verificationResponse}
						numberQuestion={numberQuestion}
						arrayQuestion={questionGameOne}
						anserwerQuestion={responseQuestionGameOne}
					/>
				</>
			)}

			{uiToShow === steps.win && (
				<ValidationResultModal
					title="¡Bien hecho!"
					numberPoints={15}
					dialogModal="Lograste relacionar correctamente los pasos para preparar un delicioso Frappé. "
					buttonTxt="Continuar"
					isCorrect={true}
					action={() => {
						dispatch(
							completeOneTask({
								idActivity: 5,
								pointsWin: 15,
								subtema: tasksId.tema2.activities.subtema2,
							})
						);
						navigator("/home2/tema2/subtema2/activityEight");
					}}
				/>
			)}

			{uiToShow === steps.fail && (
				<ValidationResultModal
					title="Respuesta incorrecta."
					dialogModal="¡Ánimo! Recuerda que es importante seguir los pasos aprendidos para preparar Frappé."
					buttonTxt="Continuar"
					isCorrect={false}
					action={() => {
						dispatch(
							completeOneTask({
								idActivity: 7,
								pointsWin: 0,
								subtema: tasksId.tema2.activities.subtema2,
							})
						);
						navigator("/home2/tema2/subtema2/activityEight");
					}}
				/>
			)}

		</>
	)
}
